import z from 'zod'

export const selectOptionZod = <T = Record<string, unknown>>() =>
  z.object({
    endAdornment: z.any().optional(),
    label: z.string(),
    logo: z.any().optional(),
    rawData: z.custom<T>().optional(),
    value: z.string(),
  })

export type SelectOptionZod<T = Record<string, unknown>> = z.infer<
  ReturnType<typeof selectOptionZod<T>>
>

export const emptySelectOptionZod = <T = Record<string, unknown>>(): SelectOptionZod<T> => ({
  endAdornment: undefined,
  label: '',
  logo: undefined,
  rawData: undefined,
  value: '',
})
